"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PromoCodeResponseMapper = void 0;
var PromoCodeResponseMapper = /** @class */ (function () {
    function PromoCodeResponseMapper(data) {
        this.localData = data;
    }
    PromoCodeResponseMapper.prototype.getDataObject = function () {
        return this.localData;
    };
    return PromoCodeResponseMapper;
}());
exports.PromoCodeResponseMapper = PromoCodeResponseMapper;
//# sourceMappingURL=PromoCodeResponseMapper.js.map


//////////////////
// WEBPACK FOOTER
// ./node_modules/@idse/checkout-ui/models/mappers/PromoCodeResponseMapper.js
// module id = 1972
// module chunks = 8